import {
  ATTR_DEPLOYMENT_ENVIRONMENT_NAME,
  ATTR_DEPLOYMENT_REGION,
  ATTR_SERVICE_NAME,
  type ResourceAttributes,
} from "../../../shared-utils/serviceIdentity";

/** Sentry's own names for the identity: `environment` plus tags. Release stays build-injected. */
export const sentryOptionsFromResource = (
  resource: ResourceAttributes
): {
  environment: string;
  initialScope: { tags: { service: string; deployment_region: string } };
} => ({
  environment: resource[ATTR_DEPLOYMENT_ENVIRONMENT_NAME],
  initialScope: {
    tags: {
      service: resource[ATTR_SERVICE_NAME],
      deployment_region: resource[ATTR_DEPLOYMENT_REGION],
    },
  },
});
